function Skeleton() {
  return (
    <div role="status" class="py-6 w-full">
      <div class="flex w-full justify-between items-center">
        <div className="w-full">
          <div class="h-6 bg-grey-200 w-full mb-2"></div>
          <div class="h-4 bg-grey-200 w-2/3"></div>
        </div>
      </div>
    </div>
  )
}

function SkeletonLine(number = 1) {
  return (
    <div role="status" class="w-full flex flex-col gap-2">
      {[...Array(number)].map(() => (
        <div className="h-6 bg-gray-200" />
      ))}
    </div>
  )
}

function SkeletonProduct(number = 1) {
  return ([...Array(number)].map(() => (
    <div className="flex flex-col">
      <div class="relative mb-2 md:mb-4">
        <div className="aspect-square relative bg-grey-200 w-full pb-[100%]"></div>
      </div>
      <div class="flex-1 mb-3">
        <div className="w-2/3 h-6 bg-grey-200"></div>
      </div>
      <div class="flex flex-col items-start">
        <div className="w-1/3 h-4 mb-2 bg-grey-200"></div>
        <div className="w-1/2 h-4 mt-2 bg-grey-200"></div>
      </div>
    </div>
  )))
}

export {
  Skeleton,
  SkeletonLine,
  SkeletonProduct
}
